import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class Role implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fName: string,
    private fMetaRole: string,
    private fIsDeletable: boolean
  ) {
    [fId, fName, fMetaRole, fIsDeletable].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get isDeletable() {
    return this.fIsDeletable;
  }

  get metaRole() {
    return this.fMetaRole;
  }

  get name() {
    return this.fName;
  }

  get updatedAt() {
    return this.fUpdatedAt;
  }
}
